<template>
  <div class="listTable">
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="date" label="笔数" :width="readonly ? 200 : 180">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="金额(元)">
        <template slot-scope="scope">
          
          <el-input-number
            :controls="false"
            v-model="scope.row.amount"
            placeholder="请输入金额"
            v-if="!readonly"
            :min="1"
          ></el-input-number>
          <div v-else>
            {{ getMoney(scope.row.amount) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="到期时间">
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.expireDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            v-if="!readonly"
          >
          </el-date-picker>
          <div v-else>
            {{ scope.row.expireDate }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" v-if="!readonly" width="180">
        <template slot-scope="scope">
          <div class="del_color" @click="del(scope.$index)">
            <i class="el-icon-delete-solid"></i>
            删除
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="table_custom_add" v-if="!readonly">
      <el-button icon="el-icon-circle-plus-outline" @click="add"
        >添加</el-button
      >
    </div>
  </div>
  <!-- 
    *     <tableCustom :tableData="tableData"  />
    *    
    *     
    *     
    *
    *
    *
    *
    *
    *
    *
   -->
</template>

<script>
import * as api from "@/api/text/text";

export default {
  name: "accessory",
  data() {
    return {};
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  computed: {
    
  },
  components: {},
  created() {},
  methods: {
    del(index) {
     
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.tableData.splice(index, 1);
      });
    },
    add() {
      this.tableData.push({
        amount: undefined,
        expireDate: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table {
  border: 1px solid #e2e2e2;
  border-right: none;
  border-bottom: none;
  th {
    background: #f2f2f2;
    color: #333;
  }
}
.action_block {
  display: flex;
  flex-direction: row;
  a {
    cursor: pointer;
    margin: 0 8px;
  }
}
.del_color {
  color: #409eff;
}
</style>
<style >
.project_style_qja_a_this .table_custom_add .el-button {
  width: 100%;
  height: 47px;
  margin-top: 20px;
}
.project_style_qja_a_this .el-input-number {
  width: 100%;
}
</style>
